"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68,384],{

/***/ 8384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BookACall = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        target: "_blank",
        rel: "noreferrer",
        "aria-label": "Open a new tab to book a 15 minute call",
        className: "text-md   h-full w-full font-bold underline  transition-colors hover:text-brand-pink hover:no-underline  " + props.className,
        href: "https://calendly.com/scrumify-at/15min",
        children: "Book a 15 min call"
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BookACall);


/***/ }),

/***/ 9068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _PopInButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2369);
/* harmony import */ var _BookACall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8384);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7650);





const Package = (props)=>{
    const packageInView = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .YD)({
        triggerOnce: true,
        rootMargin: "-50px 0px"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: packageInView.ref,
                className: "flex h-full flex-col ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex h-full flex-col bg-white  transition-opacity transition-transform duration-1000 p-4 md:p-8 " + (!packageInView.inView && " translate-y-52 opacity-0") + " " + props.duration,
                    children: [
                        props.children,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: " font-mono font-extrabold  text-[1.5rem]",
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "pt-4 md:grow",
                            children: props.subtitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "ml-1 list-inside list-disc  pt-4 text-sm font-bold",
                            children: props.packageDetails.map((packageDetail, index)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "pb-2",
                                    children: packageDetail
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full h-20 pt-4  pb-2  lg:w-full ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PopInButton__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "mailto:hello@scrumify.at",
                                type: "mail",
                                ariaLabel: "Write an email to us",
                                children: "Get in touch"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-2 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BookACall__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                className: " text-left lg:text-center text-sm "
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col transform-translate transform-opacity mb-4  bg-white p-4 pb-8 md:p-8 lg:mb-0 " + props.duration + " " + (!packageInView.inView && "translate-y-96 opacity-0"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-4 font-sans font-bold ",
                        children: "Includes:"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "ml-1 grow list-inside list-disc  text-sm",
                        children: props.features.map((feature, index)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "pb-2",
                                children: feature
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "pt-4 text-sm italic ",
                        children: props.lastPoint
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Package);


/***/ })

}]);